import { z } from 'zod';

import { PurchaseCancellationSchema } from './purchases.schema.js';
import type { CancelPurchaseRequest, CancelPurchaseResponse } from './purchases-cancel.dto.js';

export const CancelPurchaseRequestSchema: z.ZodType<CancelPurchaseRequest> = z.object({
  companyId: z.uuid(),
  storeId: z.uuid(),
  locationId: z.uuid(),
  stationId: z.uuid(),
  purchaseId: z.uuid(),
  reason: z.string().trim().min(1).max(500),
  replaceWithPurchaseId: z.uuid().nullable().optional(),
});

export const CancelPurchaseResponseSchema: z.ZodType<CancelPurchaseResponse> = z.object({
  cancellation: PurchaseCancellationSchema,
});
